// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/config/theme.js#1 $
'use strict';

/**
* @ngdoc overview
* @name tcApp.module:theme
* @description
* # theme
* Configure Angular Material theme and icons
*/

angular.module('tcApp')
.config(function($mdThemingProvider) {
	// Disable ngMaterial theming
	$mdThemingProvider.disableTheming();
})
.config(function($mdIconProvider) {
	$mdIconProvider.defaultIconSet('../images/system/system.svg?ts=' + window.sessionFileTimeStamp, //eslint-disable-line
	'32').defaultIconSize('32');
});
